/**
 * Store Application - Rebuilt with Unified Layout System
 *
 * Uses RootLayout to eliminate all auth boilerplate
 *
 * Before: 65 lines (58 lines of duplicate auth + loading)
 * After: 14 lines (clean and focused)
 */

import { RootLayout } from '@room/shared-ui';
import StorePage from './pages/Store';

export function App() {
  return (
    <RootLayout appName="Store">
      <StorePage />
    </RootLayout>
  );
}
